import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import SimpleStep from "../SimpleStep";
import { notBlank } from "../../shared/validations";
import { FIRST_NAME_PATH, ROLE_PATH } from "../../routing/paths";

const simpleStepProps = {
  previous: FIRST_NAME_PATH,
  next: ROLE_PATH,
  target: "last name",
  description: "We'll rarely use it, but it'll be good to know it.",
  spellName: "last_name",
  validation: notBlank,
};

export const LastNameStep: FunctionComponent<WizardProps> = (props: WizardProps) => {
  const firstName = props.invocations["first_name"];
  const question = `Thanks, ${firstName}! How about your`;
  return <SimpleStep wizard={props} {...simpleStepProps} question={question} />;
};

export default WizardContainer(LastNameStep);
